export enum Theme {
  LIGHT = 'light',
  DARK = 'dark',
}

export enum DetectionColors {
  Acne = '#3333ff',
  AgeWrinkles = '#39d934',
  DarkCircles = '#ff0000',
}
